<header class="custom-header">
  <div class="header-left-part">
    <div class="mod-logo">
      <ng-container *coinFeatureFlag="'displayEnvironment'">
        <div class="environment">
          <mat-icon>{{ currentEnvironment.icon }}</mat-icon>
          <div class="environment-name">
            <p class="bold">{{ currentEnvironment.type }}</p>
            @if (currentEnvironment['featurePrefix']) {
              <p class="bold">{{ currentEnvironment['featurePrefix'] }}</p>
            }
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <coin-user-menu
    [isDeputyAllowed]="false"
    [isProfileAllowed]="false"></coin-user-menu>
  <div class="header-right-part">
    @if (updateNotifications.hasUpdates()) {
      <coin-update-notifier></coin-update-notifier>
    }
  </div>
</header>
